<template>
    <div class="columns is-multiline d-flex flex-column flex-md-row">
        <section class="sidebar column is-full-mobile is-4-tablet is-3-desktop">
            <div>
                <h4 class="mb-2 text-center">Download the CAT-UXO App </h4>
                <div class="app-download-buttons d-flex mb-4">
                    <a target="_blank" href="https://apps.apple.com/by/app/cat-uxo/id6720751417?platform=iphone">
                        <img src="/img/download-on-the-app-store.png" alt="" >
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.catuxo.mobile&hl=en">
                        <img src="/img/get-it-on-google-play.png" alt="" class="">
                    </a>
                </div>
            </div>
            <cat-uxo-stacked-ads></cat-uxo-stacked-ads>
        </section>
        <section class="uxo-type column is-offset-1-desktop is-8 p-0">
            <template v-if="!fetchingIncidents">
                <div v-if="incidentsCount > 0" class="columns is-mobile align-items-center mb-2">
                    <h1 class="column is-half">IED Incidents</h1>
                    <div class="total-items font-style-16 column d-flex justify-content-end align-items-end">
                        {{ incidentsCount }} results
                    </div>
                </div>
                <cat-uxo-incidents class="columns is-mobile is-multiline"></cat-uxo-incidents>
            </template>
            <template v-else>
                <div class="content-loader">
                    <ContentLoader
                        :height="56"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                        class="mb-2"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="460" height="56"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="56"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                </div>

            </template>
            <div v-if="pageCount" class="columns mb-4 mb-lg-0">
                <div class="column is-6 py-0 mx-auto">
                    <paginate
                        :page-count="pageCount"
                        :prev-text="'&nbsp;'"
                        :next-text="'&nbsp;'"
                        :prev-link-class="'pagination-previous'"
                        :next-link-class="'pagination-next'"
                        :container-class="'pagination-list'"
                        :page-class="'pagination-item'"
                        :page-link-class="'pagination-link'"
                        :click-handler="paginate">
                    </paginate>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex";
    import {ContentLoader} from 'vue-content-loader'
    import StackedAds from "../shared/StackedAds";

    export default {
        name: "CatUxoPageIncidents",
        components: {
            ContentLoader,
            StackedAds
        },
        data: function () {
            return {}
        },
        computed: {
            ...mapState('incidents', [
                'fetchingIncidents',
                'incidentsCount',
            ]),
            ...mapGetters('incidents', [
                'pageCount',
            ])
        },
        methods: {
            ...mapActions('incidents', [
                'fetchIncidents',
            ]),
            paginate: function (page) {
                window.scrollTo(0,0);
                this.fetchIncidents({page: page})
            }
        },
        mounted() {
            this.fetchIncidents({page: 1})
        }
    }
</script>

<style scoped lang="scss">
    .content-loader {
        min-height: rem(200px);

        @include media-breakpoint-up(sm) {
            min-height: rem(300px);
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/Incidents.vue